module.exports = __webpack_public_path__ + "media/components/assets/icons/lesson_download-8e1f771078e3524fa70ec8bd0ee27491.svg";